export var Type;
(function (Type) {
    Type["UNKNOWN"] = "UNKNOWN";
    Type["ADMIN_APPROVAL"] = "ADMIN_APPROVAL";
    Type["PAID_PLANS"] = "PAID_PLANS";
    Type["EVENTS"] = "EVENTS";
})(Type || (Type = {}));
export var AllowPolicy;
(function (AllowPolicy) {
    AllowPolicy["UNKNOWN"] = "UNKNOWN";
    AllowPolicy["OWNER_AND_ADMINS"] = "OWNER_AND_ADMINS";
    AllowPolicy["OWNER"] = "OWNER";
    AllowPolicy["ALL_MEMBERS"] = "ALL_MEMBERS";
})(AllowPolicy || (AllowPolicy = {}));
export var StepKey;
(function (StepKey) {
    StepKey["UNKNOWN"] = "UNKNOWN";
    StepKey["CREATE_POST"] = "CREATE_POST";
    StepKey["REACT_TO_POST"] = "REACT_TO_POST";
    StepKey["INVITE_MEMBERS"] = "INVITE_MEMBERS";
})(StepKey || (StepKey = {}));
export var PrivacyStatus;
(function (PrivacyStatus) {
    /** Undefined group privacy status. */
    PrivacyStatus["UNKNOWN"] = "UNKNOWN";
    /** Anyone can see the group and its content. Anyone can join the group. */
    PrivacyStatus["PUBLIC"] = "PUBLIC";
    /** Anyone can see the group, but only members can see its content. New members must submit a `Join Group Request`. */
    PrivacyStatus["PRIVATE"] = "PRIVATE";
    /** Only admins and members can see the group. New members can only be added by other members. */
    PrivacyStatus["SECRET"] = "SECRET";
})(PrivacyStatus || (PrivacyStatus = {}));
export var IdentityType;
(function (IdentityType) {
    /** Wix user. */
    IdentityType["USER"] = "USER";
    /** Wix member. */
    IdentityType["MEMBER"] = "MEMBER";
})(IdentityType || (IdentityType = {}));
export var RequestStatus;
(function (RequestStatus) {
    /** Undefined request status. */
    RequestStatus["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    /** Pending group request. */
    RequestStatus["PENDING"] = "PENDING";
    /** Approved group request. */
    RequestStatus["APPROVED"] = "APPROVED";
    /** Rejected group request. */
    RequestStatus["REJECTED"] = "REJECTED";
    /** *Deprecated. Use `CANCELED`.** Cancelled group request. */
    RequestStatus["CANCELLED"] = "CANCELLED";
    /** Canceled group request. */
    RequestStatus["CANCELED"] = "CANCELED";
})(RequestStatus || (RequestStatus = {}));
export var ContentType;
(function (ContentType) {
    ContentType["PLAIN_TEXT"] = "PLAIN_TEXT";
    ContentType["DRAFTJS"] = "DRAFTJS";
    ContentType["RICH_CONTENT"] = "RICH_CONTENT";
})(ContentType || (ContentType = {}));
export var ItemsToUpdate;
(function (ItemsToUpdate) {
    /** Take into account only items which are listed in the request. */
    ItemsToUpdate["BY_ID"] = "BY_ID";
    /** Update all items. */
    ItemsToUpdate["ALL_ITEMS"] = "ALL_ITEMS";
})(ItemsToUpdate || (ItemsToUpdate = {}));
export var OwnershipFilter;
(function (OwnershipFilter) {
    /** All items. */
    OwnershipFilter["ALL"] = "ALL";
    /** Items for the current site member. */
    OwnershipFilter["CURRENT_MEMBER"] = "CURRENT_MEMBER";
})(OwnershipFilter || (OwnershipFilter = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map